import { ColumnLabel, ColumnValue } from "./Columns";
import { Product } from "../../product";

export const ProductListProductTypeColumn = {
  name: ColumnValue.ProductType,
  label: ColumnLabel[ColumnValue.ProductType],
  className: "text-column",
  renderCell: (p: Product): string => p.namespace,
};
